import { Button, TextArea } from '@calizahq/react-components-v2'
import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'

import { useAlertContext } from '@/context'
import { TicketMutations } from '@/graphql/mutations/ticket.mutations'
import { useMobile } from '@/hooks'
import { useGraphqlMutation } from '@/hooks/useGraphql'

type Props = {
  description?: string
  refetchDetails: () => void
  ticketId: number
  toggle: () => void
}

export const DescriptionField = ({ description, toggle, ticketId, refetchDetails }: Props) => {
  const { setAlert } = useAlertContext()

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(TicketMutations.updateTicket(), {
    onSuccess: () => {
      toggle()
      refetchDetails()
      setAlert('Description updated', 'success')
    },
  })

  const { isTablet } = useMobile()

  const handleSubmit = (values: FormValues) => {
    mutate({
      ticket: {
        ...values,
        ticketId,
      },
    })
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          description,
        }}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validationSchema={formSchema}
      >
        {() => {
          return (
            <Form className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
              <div className="mb-16 flex w-full flex-col md:grid md:grid-cols-1 md:gap-4">
                <TextArea className="mb-4 w-full" label="Add description" name="description" />
              </div>
              <div className="flex flex-col-reverse justify-between md:flex-row">
                <Button
                  className="w-full bg-action-secondary md:flex md:w-auto"
                  onClick={toggle}
                  size={isTablet ? 'medium' : 'small'}
                  variant="secondary"
                >
                  Close
                </Button>
                <Button
                  className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
                  disabled={isMutationLoading}
                  isLoading={isMutationLoading}
                  size={isTablet ? 'medium' : 'small'}
                  type="submit"
                >
                  Update Description
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

const formSchema = Yup.object({
  description: Yup.string().required('Please enter a description'),
})

interface FormValues {
  description?: string
}
